import React from "react";
import { Link } from "react-router-dom";
import SEO from "../../components/SEO";
import "./LegalPages.css";

const PrivacyPolicy = () => {
  return (
    <div className="legal-page">
      <SEO
        title="Privacy Policy | Lubrichem"
        description="Learn how Lubrichem collects, uses, and protects your personal information."
        url="https://yourdomain.com/privacy-policy"
      />

      <section className="legal-hero">
        <div className="container text-center">
          <h1>Privacy Policy</h1>
          <p>Your privacy is important to us.</p>
        </div>
      </section>

      <section className="legal-content">
        <div className="container">
          <div className="legal-card">
            <p className="updated">Last updated: March 2025</p>

            <h3>1. Introduction</h3>
            <p>
              Lubrichem (“we”, “our”, “us”) is committed to protecting your
              privacy. This Privacy Policy explains how we collect, use, and
              safeguard your information when you visit our website.
            </p>

            <h3>2. Information We Collect</h3>
            <ul>
              <li>Personal information (name, email, phone number)</li>
              <li>Business information submitted via contact forms</li>
              <li>Technical data such as IP address and browser type</li>
            </ul>

            <h3>3. How We Use Your Information</h3>
            <p>
              We use the collected information to respond to inquiries, improve
              our services, communicate with customers, and maintain website
              security.
            </p>

            <h3>4. Data Sharing</h3>
            <p>
              We do not sell or rent your personal data. Information may be
              shared only with trusted service providers or when legally
              required.
            </p>

            <h3>5. Data Security</h3>
            <p>
              We implement appropriate technical and organizational measures to
              protect your data against unauthorized access or disclosure.
            </p>

            <h3>6. Your Rights</h3>
            <p>
              You have the right to access, update, or request deletion of your
              personal information by contacting us.
            </p>

            <h3>7. Third-Party Links</h3>
            <p>
              Our website may contain links to third-party websites. We are not
              responsible for their privacy practices.
            </p>

            <h3>8. Changes to This Policy</h3>
            <p>
              We may update this Privacy Policy from time to time. Any changes
              will be posted on this page.
            </p>

            <h3>9. Contact Us</h3>
            <p>
              If you have any questions about this Privacy Policy, please
              contact us via our <Link to="/contact">Contact Page</Link>.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
